/*
  Модуль валидации формы
*/
import $ from 'jquery';

$.fn.formValidation = function(options) {
  function init($form) {
    var $inputs = $('[data-required]', $form);
    var $submitBtn = $('[data-submit]', $form);

    function validate() {
      var flag = true;

      $inputs.removeClass("m_invalid");
      $inputs.each(function() {
        if ($(this).val() == "") {
          flag = false;
          $(this).addClass("m_invalid");
        }
      })

      return flag;
    }

    $form.on('submit', function(e) {
      if (validate()) {
        if (options && typeof options.success === 'function') {
          options.success(e, $form);
          return false;
        }
      } else {
        return false;
      }
    });

    $inputs.on("keyup change", function() {
      if ($(this).val().length > 0) {
        $(this).removeClass("m_invalid");
      }
      else {
        $(this).addClass("m_invalid");
      }
    });
  }

  this.each(function(index, el) {
    init($(this));
  });
}
